var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BodyOneTypography } from './bodyOne';
import { BodyTwoTypography } from './bodyTwo';
import { HeaderOneTypography } from './headerOne';
import { HeaderSevenTypography } from './headerSeven';
import { HeaderTwoTypography } from './headerTwo';
import { HeaderThreeTypography } from './headerThree';
import { HeaderFourTypography } from './headerFour';
import { HeaderFiveTypography } from './headerFive';
import { HeaderSixTypography } from './headerSix';
import { subTitleTypography } from './subTitle';
import { ButtonTypography } from './button';
import { CaptionTextTypography } from './captionText';
import { ToastContentTypography } from './toastContent';
import { ToastTitleTypography } from './toastTitle';
import { linkTypography } from './link';
import { TabActiveTypography, TabTypography } from './tab';
export var typographies = {
    h1Heading: HeaderOneTypography,
    h2Heading: HeaderTwoTypography,
    h3Heading: HeaderThreeTypography,
    h4Heading: HeaderFourTypography,
    h5Heading: HeaderFiveTypography,
    h6Heading: HeaderSixTypography,
    h7Heading: HeaderSevenTypography,
    subtitle: subTitleTypography,
    button: ButtonTypography,
    body1: BodyOneTypography,
    body2: BodyTwoTypography,
    caption: CaptionTextTypography,
    link: linkTypography,
    toastContent: ToastContentTypography,
    toastTitle: ToastTitleTypography,
    tab: TabTypography,
    tabActive: TabActiveTypography,
};
var Typography = function (_a) {
    var className = _a.className, name = _a.name, children = _a.children, type = _a.type, htmlProps = __rest(_a, ["className", "name", "children", "type"]);
    var TypographyType = typographies[type];
    return (_jsx(TypographyType, __assign({ className: className, "data-testid": name }, htmlProps, { children: children }), void 0));
};
export default Typography;
